import { useClientPortalAPI, useSubmit } from "@certn/api";
import { components } from "@certn/api/generated-schemas/client-portal";
import { showToast } from "@certn/cascadia";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export function usePackageApplyLink(
  packageId: string,
  defaultApplyLinkId?: string,
  onSuccess?: () => void
) {
  const { t } = useTranslation();
  const [applyLink, setIsApplyLink] = useState("");
  const linkId = applyLink || defaultApplyLinkId;

  const { submit } = useSubmit(
    `/api/internal/client-portal/packages/${packageId}/create-default-apply-link/`,
    {
      onSuccess: ({
        id,
      }: components["schemas"]["CreateDefaultApplyLinkResponse"]) => {
        setIsApplyLink(id);
        onSuccess?.();
        showToast(t("Apply link created successfully"), { type: "success" });
      },
    }
  );

  const { data: applyLinkData, isLoading: isApplyLinkLoading } =
    useClientPortalAPI(
      linkId ? `/api/internal/client-portal/apply-links/${linkId}/` : null
    );

  const createApplyLink = async () => {
    await submit();
  };

  return {
    applyLinkData,
    isApplyLinkLoading,
    createApplyLink,
  };
}
